import { render } from "./PersonalInfoScreen.vue?vue&type=template&id=51f56fa5&scoped=true&lang=html"
import script from "./PersonalInfoScreen.vue?vue&type=script&lang=js"
export * from "./PersonalInfoScreen.vue?vue&type=script&lang=js"

import "./PersonalInfoScreen.vue?vue&type=style&index=0&id=51f56fa5&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/aethonspel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f56fa5"]])

export default __exports__